var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.82df7a26e0214cc3f5e0af00c31ae95c.svg#j';
                    var viewUrl = 'sprites.82df7a26e0214cc3f5e0af00c31ae95c.svg#view-j';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 19 18',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };